<template>
  <div class="p-checkbox">
    <input
      :id="id"
      type="checkbox"
      :checked="isChecked"
      :value="value"
      :name="name"
      :disabled="disabled"
      :class="['p-checkbox__field', `p-checkbox__field--${size}`]"
      :data-test="testAttribute"
      @change="onChange"
    />
    <label v-if="$slots.append" class="p-checkbox__append" :for="id">
      <slot name="append" />
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const emit = defineEmits(['update:modelValue', 'onChange'])

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: [Boolean, Array],
    required: true,
  },
  value: {
    type: [String, Number, Boolean],
    default: true,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: Boolean,
  size: {
    type: String,
    default: 'md',
    validator: (val: string) => ['sm', 'md'].includes(val),
  },
})

const testAttribute = dataTest(props.name)

const isChecked = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(props.value)
  } else {
    return props.modelValue
  }
})

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement

  if (Array.isArray(props.modelValue)) {
    const newValue = [...props.modelValue]
    const index = newValue.indexOf(props.value)

    if (target.checked && index === -1) {
      newValue.push(props.value)
    } else if (!target.checked && index !== -1) {
      newValue.splice(index, 1)
    }

    emit('update:modelValue', newValue)
    emit('onChange', newValue)
  } else {
    emit('update:modelValue', target.checked)
    emit('onChange', target.checked)
  }
}
</script>
